import formatterOnlyNumber from './onlyNumbers';

function decimal(value: number, decimal: number): string {
  const valueString = String(value).replace('.', ',');
  let valueFormatted = valueString;
  const period = valueFormatted.indexOf(',');

  if (period > -1) {
    valueFormatted =
      valueFormatted.substring(0, period).replace(/\s|\D/g, '') +
      valueFormatted.substring(period + 1).replace(/\s|\D/g, '');
  }
  let len = valueFormatted.length;
  while (len <= decimal) {
    valueFormatted = `0${valueFormatted}`;
    len = valueFormatted.length;
  }
  valueFormatted = `${valueFormatted.substring(
    0,
    len - decimal,
  )},${valueFormatted.substring(len - decimal, len)}`;
  while (valueFormatted.length > 4 && valueFormatted[0] === '0') {
    valueFormatted = valueFormatted.substring(1);
  }
  if (valueFormatted[0] === ',') {
    valueFormatted = `0${valueFormatted}`;
  }
  return valueFormatted;
}

function formatterDecimal(value: string, decimalPlaces: number): string {
  const valueClean = formatterOnlyNumber(value);
  const n = valueClean[valueClean.length - 1];
  if (!value) {
    return '';
  }
  if (Number.isNaN(n)) {
    const moneyTypingFormatted = valueClean.substring(0, valueClean.length - 1);
    return moneyTypingFormatted;
  }
  const valueFormatted = decimal(Number(valueClean), decimalPlaces);
  return valueFormatted;
}

export default formatterDecimal;
